<script lang="ts">import DisplayText from '../Typography/DisplayText/DisplayText.svelte';
import Grid from '../Grid/Grid.svelte';
import ParagraphHeading from '../Typography/ParagraphHeading/ParagraphHeading.svelte';
const { backgroundColor = 'default', colorMode = 'light', headerAlignment = 'left', headerGap = '60', headingText = '', headingLevel = 'h2', paddingTop = '120', paddingBottom = '120', variant = 'primary', background, ctaItems, children, class: className = '', ...rest } = $props();
</script>

<section
  {...rest}
  class="Section Section-variant--{variant} Section-header-alignment--{headerAlignment} {className}"
  class:Section-background-color--light-gray={backgroundColor === 'light-gray'}
  data-color-mode={colorMode}
  style:--section-padding-top="var(--space-responsive-{paddingTop})"
  style:--section-padding-bottom="var(--space-responsive-{paddingBottom})"
  style:--section-header-gap="var(--space-responsive-{headerGap})"
>
  {#if background}
    <div class="background-container">
      {@render background?.()}
    </div>
  {/if}

  <Grid class="Section__content-wrapper">
    {#if headingText || ctaItems}
      <Grid as="header" class="Section__header">
        {#if headingText}
          {@const Heading = variant === 'tertiary' ? ParagraphHeading : DisplayText}
          {@const headingVariant = variant === 'primary' ? 'large' : 'small'}
          <div class="Section__heading">
            <Heading as={headingLevel} variant={headingVariant} isBalanced={true}>
              {@html headingText}
            </Heading>
          </div>
        {/if}
        {#if ctaItems}
          <div class="Section__slot-cta-items">
            {@render ctaItems?.()}
          </div>
        {/if}
      </Grid>
    {/if}

    {#if children}
      <div class="Section__slot-default">
        {@render children?.()}
      </div>
    {/if}
  </Grid>
</section>

<style>/**
 * Do not edit directly, this file was auto-generated.
 * Thu, 24 Jul 2025 14:45:23 GMT
 */
/**
 We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
 */
@layer design-system-components.pwds {
  .Section {
    --color: var(--color-text);
    --section-background-color: var(--color-background);
    position: relative;
    display: grid;
    place-content: center;
    padding-top: var(--section-padding-top);
    padding-bottom: var(--section-padding-bottom);
    background-color: var(--section-background-color);
  }
  .Section :global(.Section__content-wrapper) {
    row-gap: var(--section-header-gap);
  }
  .Section-background-color--light-gray {
    --color: var(--color-mode-light-text);
    --section-background-color: var(--color-neutral-900);
  }
  :global(.Section__content-wrapper) {
    position: relative;
    z-index: 1;
  }
  :global(.Section__header),
  .Section__heading {
    grid-column: span 12;
  }
  .Section__slot-cta-items {
    display: flex;
    gap: var(--space-10);
    grid-column: span 12;
  }
  .Section__slot-default {
    grid-column: span 12;
  }
  @media (min-width: 46.25rem) {
    .Section-variant--primary.Section-header-alignment--left .Section__heading,
    .Section-variant--secondary.Section-header-alignment--left .Section__heading {
      grid-column: span 9;
    }
    .Section-variant--primary.Section-header-alignment--left .Section__slot-cta-items,
    .Section-variant--secondary.Section-header-alignment--left .Section__slot-cta-items {
      grid-column: span 3;
      align-self: flex-end;
      justify-content: flex-end;
    }
  }
  .Section-variant--primary.Section-header-alignment--center .Section__heading,
  .Section-variant--secondary.Section-header-alignment--center .Section__heading {
    text-align: center;
  }
  @media (min-width: 64rem) {
    .Section-variant--primary.Section-header-alignment--center .Section__heading,
    .Section-variant--secondary.Section-header-alignment--center .Section__heading {
      grid-column: 2/span 10;
    }
  }
  @media (min-width: 105rem) {
    .Section-variant--primary.Section-header-alignment--center .Section__heading,
    .Section-variant--secondary.Section-header-alignment--center .Section__heading {
      grid-column: 3/span 8;
    }
  }
  .Section-variant--primary.Section-header-alignment--center .Section__slot-cta-items,
  .Section-variant--secondary.Section-header-alignment--center .Section__slot-cta-items {
    justify-content: center;
  }
  .Section-variant--tertiary :global(.Section__header) {
    grid-template-columns: 1fr;
    align-self: flex-start;
    gap: var(--space-10);
    width: auto;
    margin-right: var(--space-none);
    margin-left: var(--space-none);
  }
  @media (min-width: 64rem) {
    .Section-variant--tertiary :global(.Section__header) {
      grid-column: 1/span 4;
    }
  }
  .Section-variant--tertiary .Section__heading {
    grid-column: span 1;
  }
  .Section-variant--tertiary .Section__slot-cta-items {
    grid-column: span 1;
    justify-content: flex-start;
  }
  @media (min-width: 64rem) {
    .Section-variant--tertiary .Section__slot-default {
      grid-column: span 8;
    }
  }
  .background-container {
    position: absolute;
    inset: 0;
  }
  .background-container :global(*) {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}</style>
